var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "25", height: "24", fill: "none", viewBox: "0 0 25 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { stroke: "#018489", d: "M14.1791 14L3.17914 3M14.1791 14L10.6791 21C10.6353 21.0957 10.5648 21.1769 10.4762 21.2338C10.3875 21.2906 10.2844 21.3209 10.1791 21.3209C10.0738 21.3209 9.97071 21.2906 9.88208 21.2338C9.79344 21.1769 9.723 21.0957 9.67913 21L3.17914 3M14.1791 14L21.1791 10.5C21.2749 10.4561 21.356 10.3857 21.4129 10.2971C21.4698 10.2084 21.5 10.1053 21.5 10C21.5 9.89468 21.4698 9.79158 21.4129 9.70295C21.356 9.61431 21.2749 9.54387 21.1791 9.5L3.17914 3", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});